<template>
  <div>
    <div class="swpier">
      <img :src="swiperImage" alt="">
    </div>
    <!-- <div class="product animated-fadeInUp" data-wow-delay="0.4s" style="animation-name: fadeInUp;" v-if="productList.length > 0"> -->
      <div class="product animated-fadeInUp1" data-wow-delay="0.4s" style="animation-name: fadeInUp;">
        <div class="product-cont">
        <div class="product-num">
          共<nobr>{{productList.length?productList.length:0}}</nobr>条搜索结果
        </div>
        <div class="product-box" v-if="productList.length">
          <div class="product-lsit" v-for="(item, index) in productList " :key="index"  @click="getDetails(item)">
            <div class="item-image-box">
              <img :src="item.image" alt="">
            </div>
            <div class="item-title">{{ item.title }}</div>
            <div class="item-content">{{ item.description }}</div>
            <div class="product-lsit-button">
              <i class="el-icon-top-right" color="#FFFFFF"></i> More
            </div>
          </div>
        </div>
        <div class="product-zero" v-else>
          抱歉，没有找到您查询的内容
        </div>
      </div>
    </div>
    <!-- <div class="product" v-else>
        <div class="product-null">
          <div class="search-count-box">
          <div class="txt">共</div><em>0</em><div>条搜索结果</div>
          <div></div>
        </div>
        </div>
    </div> -->
    <footerBotom></footerBotom>
  </div>
</template>
<script>
import { divisionList,nav } from '@/request/api';
import footerBotom from '@/components/footer.vue'

export default {
  components: {
    footerBotom
  },
  data() {
    return {
      productList: [],
      total: 0,
      page: 1,
      pageSize: 10,
      swiperImage:"",
      keyword:""
    }
  },
  created() {
    this.getData()
  },
  // mounted() {
  //   // this.getParams();
  // },
  // watch: {
  //   '$route'(){
  //    this.getParams();
  //   }
  // },
  methods: {
    getParams() {
      if (this.$route.query.keyword) {

        this.keyword = this.$route.query.keyword
        console.log(this.$route.query.keyword,this.keyword,'==============');
        this.getList()
      }
    },
    getData(){
      this.getList()
      this.getNav()
    },
    getNav(){
      let {search_conf} =  JSON.parse(localStorage.getItem('info'))
      this.swiperImage = search_conf.image

      // nav({}).then(res=>{
      //   this.swiperImage = res.data[2].image
      // })
      // this.swiperImage = '../../static/image/search.png';
    },
    getList() {
      divisionList({ page: this.page, pageSize: this.pageSize, channel: 3, keyword: this.$route.query.keyword }).then(res => {
        if (res.code == 1) {
          this.total = res.data.total
          this.productList = res.data.list
        }
      })
    },

    handleSizeChange(val) {
    },
    handleCurrentChange(val) {
      this.page = val
      this.getList()
    },
    getDetails(item) {
      this.$router.push({
        path: '/productDetails',
        query: {
          channel: this.channel,
          productId: item.id,
        }
      })
    },

  },
}
</script>
<style lang="scss" scoped>
.swpier {
  margin-top: 90px;
  width: 100%;

  img {
    width: 100%;
    height: 100%;
    vertical-align: middle;
  }
}
.product-null {
  padding-top: 60px;
}
.search-count-box {
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: bold;

  em {
    font-style:normal;
    font-size:24px;
    padding: 0 5px;
    color: #DB2733;
  }
}
.product-num{
  padding-bottom: 30px;
  font-size:24px;
  font-weight: bold;
  color: #333333;
  nobr{
    color: #DB2733;
  }

  border-bottom:1px solid #eaeaea;
}

.product-box{
  padding-top:50px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .product-lsit {
  cursor: pointer;
  margin-right: 40px;

  margin-bottom: 70px;
  width: calc(100% / 3 - 40px);

  .item-image-box {
    width: 100%;
    height: 438px;
    background: #F7F7F7;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 262px;
      height: 284px;
    }
  }

  .item-title {
    margin-top: 21px;
    font-size: 24px;
    text-align: center;
    font-family: Arial-Bold, Arial;
    font-weight: bold;
    color: #333333;
  }

  .item-content {
    font-size: 15px;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-top: 8px;
    text-align: center;

    color: #999999;
    line-height: 26px;
  }

  .product-lsit-button {
    margin: 0 auto;
    margin-top: 23px;
    width: 202px;
    height: 43px;
    text-align: center;
    line-height: 43px;
    border-radius: 29px;
    border: 2px solid #333333;
    font-size: 18px;

    color: #333333;
  }

  .product-lsit-button:hover {
    border: 2px solid #DB2733;
    background: #DB2733;
    color: #FFFFFF;
  }
}

.product-lsit:last-child {
  margin-right: 0px !important;
}

}

.product-zero{
  padding: 160px 0 110px;
  text-align: center;
  font-size: 18px;
  color: #333333;
}

@media screen and (max-width:767px) {
  .product-box {
    display: block !important;
    .product-lsit{
      margin-right: 0 !important;
      width: 100% !important;
    }
  }
  .right {
    width: calc(100% / 2) !important;

    // display: block !important;
    .product-lsit {
      margin-right: 0 !important;
      width: 100% !important;
      margin-bottom: 30px !important;

      .item-image-box {
        height: auto !important;

        img {
          width: 70% !important;
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/seach.vue